export default __webpack_public_path__ + "static/media/login-email.822f34d3.svg";